import KudosStarIcon from '@assets/icons/KudosStar'
import { useDialog } from '@globals/dialog/useDialogStore'
import { usePWAInstallationPromptStore } from '@globals/stores/usePWAInstallationPromptStore'
import { colors } from '@globals/themes/defaultTheme'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import CloseButton from '@shared/components/button/CloseButton'
import { T } from '@transifex/react'
import { SyntheticEvent, useEffect, useState } from 'react'
import PWAInstallationModal from './PWAInstallationModal'

const dialogKey = 'pwaInstallationPrompt'

type BeforeInstallPromptEvent = Event & {
  prompt: () => void
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>
}

const cardStyle = {
  p: 2,
  boxShadow: 'none',
  backgroundColor: colors.blueUltraLight,
  borderRadius: 0,
}

const PWAInstallationPrompt = () => {
  const [promptInstall, setPromptInstall] = useState<Event | null>(null)
  const { openDialog } = useDialog(dialogKey)
  const { dismissed, setDismissed } = usePWAInstallationPromptStore()

  useEffect(() => {
    const handler = (e: Event) => {
      e.preventDefault()
      setPromptInstall(e)
    }
    window.addEventListener('beforeinstallprompt', handler)

    return () => window.removeEventListener('transitionend', handler)
  }, [])

  if (dismissed) {
    return null
  }

  const onClick = (evt: SyntheticEvent<HTMLElement, Event>) => {
    evt.preventDefault()

    if (!promptInstall) {
      return openDialog()
    }
    ;(promptInstall as BeforeInstallPromptEvent).prompt()
  }

  return (
    <>
      <Card sx={cardStyle}>
        <Stack direction="row" alignItems="center" spacing={1.5}>
          <KudosStarIcon />
          <Stack>
            <Button variant="text" id="btnPWAInstall" onClick={onClick}>
              <T _str="Add Kudos to your home screen" />
            </Button>
            <Typography variant="caption">
              <T _str="For the best mobile experience" />
            </Typography>
          </Stack>
          <Box sx={{ flexGrow: 1 }} />
          <CloseButton
            id="btnClosePWAInstallationPrompt"
            ariaLabel="Close PWA installation prompt"
            onClose={() => setDismissed(true)}
            sx={{ position: 'unset' }}
          />
        </Stack>
      </Card>
      <PWAInstallationModal
        dialogKey={dialogKey}
        listItem1={<T _str="You can add Kudos to your home screen for quicker access" />}
        listItem2={
          <span>
            <T
              _str="Open your browser menu and select {boldAddToHomeScreen}"
              boldAddToHomeScreen={
                <b>
                  <span>
                    <T _str="Add to home screen" />
                  </span>
                </b>
              }
            />
          </span>
        }
      />
    </>
  )
}

export default PWAInstallationPrompt
